import { FC, useEffect } from 'react';

import { useUser } from '../../../../../../user/useUser';
import { useRestrictedModal } from '../../../../../../components/modal/useRestrictedModal';

type Props = {
  container: HTMLDivElement;
};

/**
 * @name forEach
 * @description This function takes an array of Element and loop over it. It is useful because IE11 does not have
 * NodeList.prototype.forEach so Array.from transform it to an Array
 */
const forEach = (
  elements: NodeListOf<Element>,
  callback: (value: Element, index: number, array: Element[]) => void,
): void => Array.from(elements).forEach(callback);

/**
 * @name restrictLinks
 * @description Parse elements and open restricted modal when the element is clicked
 */

const restrictLinks = (
  key: string,
  source: string,
  openRestrictedModal: (params: { source: string }) => void,
  container: HTMLDivElement,
) => {
  const elements = container.querySelectorAll(`[${key}]`);

  forEach(elements, (element: Element) => {
    element.setAttribute('href', '');
    element.addEventListener('click', (event) => {
      event.preventDefault();
      openRestrictedModal({ source });
    });
  });
};

const links = [{ key: 'data-legislation', source: 'legislation' }];

export const RestrictLinks: FC<Props> = ({ container }) => {
  const { openRestrictedModal } = useRestrictedModal();
  const { accessPremium, currentUser } = useUser();
  useEffect(() => {
    if (!accessPremium && !currentUser.isSnapshotsCrawler) {
      links.forEach(({ key, source }) =>
        restrictLinks(key, source, openRestrictedModal, container),
      );
    }
  }, []);

  return null;
};
